export const leadsTableColumn = [
  { Header: 'Customer Name', accessor: 'customerName', width: '13%' },
  { Header: 'Mobile Number', accessor: 'mobileNumber', width: '10%' },
  { Header: 'Tags', accessor: 'tags', width: '15%' },
  { Header: 'Source', accessor: 'source', width: '10%' },
  { Header: 'Assignee', accessor: 'assignee', width: '16%' },
  { Header: 'Status', accessor: 'status', width: '16%' },
  { Header: 'Actions', accessor: 'actions', width: '8%' }
];

export const addLeadOptions = [
  {
    id: '1',
    value: 'add-manually',
    label: 'Add Manually',
    iconName: 'add-user-dark'
  },
  {
    id: '2',
    value: 'import-csv',
    label: 'Import CSV/Excel',
    iconName: 'file-upload-dark'
  }
];

export const fieldOptions = {
  status: {
    id: 1,
    label: 'Status',
    field: 'status'
  },
  source: {
    id: 2,
    label: 'Source',
    field: 'source'
  },
  tags: {
    id: 3,
    label: 'Tags',
    field: 'tags'
  },
  assignee: {
    id: 4,
    label: 'Assignee',
    field: 'assignee'
  },
  dateRange: {
    id: 5,
    label: 'Lead Creation Date',
    field: 'dateRange'
  }
};

export type CustomField = {
  key: string;
  value: any;
};
